import * as React from 'react';
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const toggleBase = cn(
  'inline-flex min-w-0 w-full items-center justify-center gap-2',
  'rounded-lg whitespace-nowrap',
  'border border-greyscale-300 bg-greyscale-0',
  'disabled:pointer-events-none disabled:opacity-50',
  'data-[state=on]:bg-transparent data-[state=on]:font-black data-[state=on]:border-greyscale-1000 data-[state=on]:ring-1 data-[state=on]:ring-inset data-[state=on]:ring-greyscale-1000',
  '[&_svg]:pointer-events-none [&_svg:not([class*="size-"])]:size-4 [&_svg]:shrink-0',
  'hover:ring-2 hover:ring-greyscale-1000',
  'focus-visible:outline-2 focus-visible:outline-greyscale-300',
  'aria-invalid:border-destructive aria-invalid:ring-1 aria-invalid:ring-inset aria-invalid:ring-destructive'
);

const toggleVariants = cva(toggleBase, {
  variants: {
    size: {
      default: 'h-14 px-4 py-5',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

function Toggle({
  className,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>) {
  return <TogglePrimitive.Root data-slot="toggle" className={cn(toggleVariants({ size, className }))} {...props} />;
}

export { Toggle, toggleVariants };
